import { useUser } from "@modules/auth/hooks/useUser"
import { useSelectedBoxId } from "@modules/box/useBox"
import { Config } from "@modules/config"
import { word } from "@modules/core/utils/i18n"
import { DebugDialog } from "@modules/debug/debugDialog"
import { useDebug } from "@modules/debug/useDebug"
import { ProfileAvatarForm } from "@modules/profile/myProfile/components/profileAvatarForm"
import { ProfileForm } from "@modules/profile/myProfile/components/profileForm"
import { ProfilePrograms } from "@modules/profile/myProfile/components/profilePrograms"
import { PublicProfileInfoResume } from "@modules/profile/publicProfile/components/publicProfileInfoResume"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { ErrorCard } from "@modules/ui/components/error/errorCard"
import { HUButton } from "@modules/ui/components/huButton"

export const ProfilePage: React.FC = () => {
  const user = useUser()
  const boxId = useSelectedBoxId()
  const { visible, setVisible, onDebugClick } = useDebug()
  const { sidebarNavigateTo } = useSidebar()

  const onOpenMyProfile = () => {
    if (user) {
      sidebarNavigateTo({
        content: <PublicProfileInfoResume userId={user.id} />,
        replaceAllComponents: true,
      })
    }
  }

  return (
    <div className="flex flex-column gap-6 w-full flex-grow-1">
      <div className="flex flex-column lg:flex-row flex-grow-1 xl:gap-4 lg:gap-2 md:gap-2">
        {/* Left column */}
        <div className="flex flex-column lg:col-4 flex-grow-1 gap-4">
          {user ? <ProfileAvatarForm user={user} /> : <ErrorCard />}
          <HUButton
            data-testid="see-public-profile"
            colorType="Underline"
            type="Default"
            size="M"
            text={word("profile.form.seePublicProfile")}
            onClick={onOpenMyProfile}
            className="align-self-center"
          />

          <ProfilePrograms openProgramDisabled={!!boxId} />
        </div>

        {/* Right column */}
        <div className="flex lg:col-7 xl:col-6 mr-2">{user ? <ProfileForm user={user} /> : <ErrorCard />}</div>
      </div>

      {/* Version information */}
      <div className="flex flex-column mx-auto md:mx-0 align-items-center" onClick={onDebugClick}>
        {Config.ENV !== "prod" ? Config.ENV + "-" : ""}
        {__VERSION__}-{__GIT_HASH__}
      </div>
      <DebugDialog visible={visible} setVisible={setVisible} />
    </div>
  )
}
